import { inject, Injectable } from '@angular/core';
import { IChecklist2ImportWarning } from './fi-checklist2-import/fi-checklist2-import';
import { FiChecklist2ImportWarningType } from './fi-checklist2-import/fi-checklist2-import-enums';
import { AppTextService } from '../../app-text';

@Injectable()
export class FiChecklist2ImportTextsService {
    appTextService = inject(AppTextService);

    getChecklistImportWarningText(warning: IChecklist2ImportWarning) {
        if (warning.WarningType === FiChecklist2ImportWarningType.InvalidComplianceThreshold) {
            return this.appTextService.get('checklist.import_invalid_compliance_threshold', {
                '{n}': this.getCellPosition(warning),
            });
        }
        if (warning.WarningType === FiChecklist2ImportWarningType.InvalidScoringValue) {
            return this.appTextService.get('checklist.import_invalid_scoring_value', {
                '{n}': this.getCellPosition(warning),
            });
        }
        if (warning.WarningType === FiChecklist2ImportWarningType.InvalidColumnHeader) {
            return this.appTextService.get('checklist.import_invalid_column_header', { '{n}': warning.ColumnStr });
        }
        if (warning.WarningType === FiChecklist2ImportWarningType.InvalidSheetName) {
            return this.appTextService.get('checklist.import_invalid_sheet_name', { '{name}': warning.Value });
        }
        throw new Error(`$getChecklistImportWarningText: unknown warningType}: ${warning.WarningType}`);
    }

    private getCellPosition(warning: IChecklist2ImportWarning): string {
        return `${warning.ColumnStr}${warning.Row}`;
    }
}
